import { render, staticRenderFns } from "./moderatorHangsUp.vue?vue&type=template&id=65dca448&scoped=true&"
import script from "./moderatorHangsUp.vue?vue&type=script&lang=js&"
export * from "./moderatorHangsUp.vue?vue&type=script&lang=js&"
import style0 from "./moderatorHangsUp.vue?vue&type=style&index=0&id=65dca448&scoped=true&lang=scss&"
import style1 from "./moderatorHangsUp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dca448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VDialog,VSpacer})
